var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container lnb d_container"},[_c('div',{staticClass:"contents_wrap"},[_c('div',{staticClass:"contents list-container"},[_c('div',{staticClass:"title"},[_vm._v(" 밍글 내역 ")]),_c('div',{staticClass:"list-content"},[_c('point-list-component',{attrs:{"pointType":`pointAllHistory`}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }